import { ToggleButton, ToggleButtonGroup } from 'component-library';
import { useTranslation } from 'react-i18next';

import { MAP_BACKGROUND, MapBackground, useControlsContext } from '@/components/widgets/o/Map/hooks/useFormControls';

import { SectionTitle, SectionWrapper } from './Sections';

export const BackgroundToggle = () => {
  const { t } = useTranslation();
  const controlsForm = useControlsContext();
  const mapBackground = controlsForm.watch('mapBackground');

  const handleOnChange = (value: MapBackground) => {
    controlsForm.setValue('mapBackground', value);
  };

  return (
    <SectionWrapper>
      <SectionTitle text={t('shared.projects.project.mapLayerEditMenu.background.labels.background')} />
      <ToggleButtonGroup value={mapBackground} onChange={handleOnChange} size='small' className='grid grid-cols-2'>
        <ToggleButton value={MAP_BACKGROUND.satellite}>
          {t('shared.projects.project.mapLayerEditMenu.background.labels.satellite')}
        </ToggleButton>
        <ToggleButton value={MAP_BACKGROUND.light}>
          {t('shared.projects.project.mapLayerEditMenu.background.labels.map')}
        </ToggleButton>
      </ToggleButtonGroup>
    </SectionWrapper>
  );
};
